import styles from './styles.module.scss';
import { useGeneratorsStore } from '../../store/zustand/useGeneratorsStore';
import { useDragonHealthStore } from '../../store/zustand/useDragonHealthStore';
import { useGameStatusStore } from '../../store/zustand/useGameStatusStore';
import { useGameStatsStore } from '../../store/zustand/useGameStatsStore';
import { useTranslation } from 'react-i18next';
import { humanNumber, humanTime } from '@game-libs/exc-libs/src/helpers';
import { unitStats } from '../../stats';

export const Statistics = () => {
  const dragonHealth = useDragonHealthStore((s) => s.dragonHealth);
  const dragonName = useGameStatusStore((s) => s.dragonName);
  const generators = useGeneratorsStore((store) => store.generators);
  const ticksCount = useGameStatsStore((s) => s.byLevel[s.activeLevelId].ticksCount);
  const { t, i18n } = useTranslation('statistics');
  const lang = i18n.language;

  const battleDuration = humanTime(ticksCount, lang);

  const { click: clickStats, total: totalStats, catapult: catapultStats } = unitStats;
  const catapultTicksToShoot = generators.catapult.ticksToGenerate ?? 1;
  const dragonDeathEstimate = humanTime(dragonHealth > 0 ? dragonHealth / (totalStats.damagePerTick ?? 1) : 0, lang);

  return (
    <div className={`${styles.statisticsContainer}`}>
      <div className={`${styles.statisticsContainer}`}>
        <h3>{t('section.fight')}</h3>
        <p>
          <span
            dangerouslySetInnerHTML={{
              __html: t('battleDuration', {
                time: battleDuration.value,
                timePrefix: battleDuration.prefix,
              }),
            }}
          ></span>
        </p>

        <p>
          <span
            dangerouslySetInnerHTML={{
              __html: t(dragonName === 'dummy' ? 'dummyEstimatedVictory' : 'estimatedVictory', {
                postProcess: 'interval',
                count: Math.max(0, dragonDeathEstimate.value),
                timePrefix: dragonDeathEstimate.prefix,
              }),
            }}
          ></span>
        </p>
      </div>

      <div className={`${styles.statisticsContainer}`}>
        <h3>{t('section.clicks')}</h3>
        <p>
          <span
            dangerouslySetInnerHTML={{
              __html: t('dpc', {
                dpc: humanNumber(clickStats.damagePerClick ?? 0),
              }),
            }}
          ></span>
        </p>

        <p>
          <span
            dangerouslySetInnerHTML={{
              __html: t('gpc', {
                gpc: humanNumber(clickStats.goldGeneration ?? 0),
              }),
            }}
          ></span>
        </p>
      </div>

      <div className={`${styles.statisticsContainer}`}>
        <h3>{t('section.units')}</h3>
        <p>
          <span
            dangerouslySetInnerHTML={{
              __html: t('dps', {
                dps: humanNumber(totalStats.damagePerTick ?? 0),
              }),
            }}
          ></span>
        </p>

        <p>
          <span
            dangerouslySetInnerHTML={{
              __html: t('gps', {
                gps: humanNumber(totalStats.goldGeneration ?? 0),
              }),
            }}
          ></span>
        </p>
      </div>

      {generators.catapult.owned > 0 && (
        <div className={`${styles.statisticsContainer}`}>
          <h3>{t('section.catapult')}</h3>
          <p>
            <span
              dangerouslySetInnerHTML={{
                __html: t('catapultDamage', {
                  damage: humanNumber(catapultStats.damagePerTick ?? 0),
                }),
              }}
            ></span>
          </p>

          <p>
            <span
              dangerouslySetInnerHTML={{
                __html: t('catapultTimeToShoot', {
                  time: catapultTicksToShoot,
                }),
              }}
            ></span>
          </p>
        </div>
      )}
    </div>
  );
};
